import React, { type FunctionComponent } from 'react'
import { type ApolloError } from 'apollo-client'
import LoadingDots from 'legacy/components/LoadingDots'
import Table from 'legacy/components/Table/Table'
import { useStoreGroupListTableColumns } from 'legacy/sections/store-groups/components/list/utils/tableColumns.hooks'
import { StoreGroupsLoadError } from 'legacy/sections/store-groups/components/error/StoreGroupsLoadError'
import { StoreGroupsListEmptyState } from 'legacy/sections/store-groups/components/list/components/StoreGroupsListEmptyState'
import { type StoreGroup } from 'legacy/common/graphql-types/retailerLocationGroup.types'

export interface StoreGroupsListBodyProps {
  storeGroups: StoreGroup[]
  loading: boolean
  error?: ApolloError
  onEditClicked?: (storeGroupId: string) => void
}
export const StoreGroupsListBody: FunctionComponent<StoreGroupsListBodyProps> = ({
  storeGroups,
  loading,
  error,
  onEditClicked,
}) => {
  const columns = useStoreGroupListTableColumns({ onEditClicked })

  if (error) {
    return <StoreGroupsLoadError />
  }

  if (loading) {
    return <LoadingDots centered />
  }

  if (storeGroups.length === 0) {
    return <StoreGroupsListEmptyState />
  }

  return <Table columns={columns} data={storeGroups} paginated />
}
